import React , {Component} from 'react';
import $ from 'jquery';

export class DymnamicBackground extends Component {
  constructor(props) {
    super(props);
    this.state = {
      seconds: parseInt(props.startTimeInSeconds, 500) || 0
    };
  }

  bgStyle = {
    color: 'blue',
    backgroundImage: 'url(' + this.props.bg + ')'
  };

  gettime() {
    return (
      new Date().getHours()
    )
  }

  tick() {
    // $('<div class="backgroundImage ' + this.state.seconds + '" style="background-image: url(' + this.state.bg + ')"></div>').hide().prependTo('.site').fadeIn(600);
    // $('.site > .backgroundImage:gt(1)').delay(5000).remove()
    this.setState(state => ({
      seconds: state.seconds + 1,
      bg: this.state.bg + state.seconds
    }));
  }

  componentDidMount() {
    this.setState(state => ({
      seconds: state.seconds + 1,
      bg: state.bg + state.seconds
    }));
    // $('<div class="backgroundImage" style="background-image: url(' + this.bgStyle + ')"></div>').hide().prependTo('.site').fadeIn(200);
    // $('.site .backgroundImage:gt(1)').delay(5000).remove()
    this.interval = setInterval(() => this.tick(), 600);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <section>
      <h3>{this.props.test}</h3>
      <h3>{this.props.bg}</h3>
      <div className="backgroundImage" style={this.bgStyle}></div>
      </section>
    )
  }
}

export default DymnamicBackground;